import { getConversationById } from '@app/helpers'
import { ConversationItem, MessageItem } from '@app/models'

import { ChatState, FetchTranslatedMessagesSuccessPayload } from '../types'

export const onFetchTranslatedMessagesSuccess = (
  state: ChatState,
  { conversationId, messages }: FetchTranslatedMessagesSuccessPayload
): ChatState => {
  const conversation = getConversationById(state.conversations, conversationId)
  if (!conversation) {
    return state
  }

  const updatedMessages = messages.reduce(
    (acc: MessageItem[], newMsg) => {
      const index = acc.findIndex((msg) => msg.id === newMsg.id)
      if (index !== -1) {
        return acc.map((msg, i) =>
          i === index
            ? {
              ...msg,
              content: newMsg.content,
              translations: newMsg.translations,
            }
            : msg
        )
      }
      return [...acc, newMsg]
    },
    [...conversation.messages]
  )

  const conversations: Record<number, ConversationItem> = {
    ...state.conversations,
    [conversationId]: {
      ...conversation,
      messages: updatedMessages,
      fetching: 'SUCCEED',
    },
  }

  return {
    ...state,
    conversations,
  }
}
